<template>
    <PopupRouterView :showLeftIcon="true" label="User Info Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="userinfo"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="userInfoInput">
        <b-card header="UserInfo" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-user-name" label-cols-lg="12"  label="User Name" label-for="input-user-name" size="sm" :model.sync="model.userName" :isRequired="true" :state="validateState('userName')" :errorMessage="getErrorMessage(errorMessage.userName, 'userName')"   />
						<app-input-textbox id="fieldset-first-name" label-cols-lg="12"  label="First Name" label-for="input-first-name" size="sm" :model.sync="model.firstName" :isRequired="true" :state="validateState('firstName')" :errorMessage="getErrorMessage(errorMessage.firstName, 'firstName')"   />
						<app-input-textbox id="fieldset-last-name" label-cols-lg="12"  label="Last Name" label-for="input-last-name" size="sm" :model.sync="model.lastName"   />
						<app-input-textbox id="fieldset-password" type="password" label-cols-lg="12"  label="Password" label-for="input-password" size="sm" :model.sync="model.password"   />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-email" label-cols-lg="12"  label="Email" label-for="input-email" size="sm" :model.sync="model.email"   />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId" :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" />
						<app-input-textbox v-if="false" id="fieldset-user-level" label-cols-lg="12"  label="User Level" label-for="input-user-level" size="sm" type="number" :model.sync="model.userLevel"   />
						<app-input-combobox-autocomplete v-if="false" :options="approvalGroups" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approval Group" id="fieldset-approval-group" size="sm" :model.sync="model.approvalGroupId"   :selected="model.approvalGroup != null ? model.approvalGroup.name : ''" @input="getApprovalGroups"   :isSelectMethodExists="true" @onSelectMethod="setSelectedApprovalGroup" />
				</b-col>

            </b-row>
        </b-card>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoList from '@/models/UserInfo/UserInfoList';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalGroup from '@/models/ApprovalGroup/ApprovalGroup';
import ApprovalGroupFilter from '@/filters/ApprovalGroup/ApprovalGroupFilter';
import PopupRouterView from '@/components/PopupRouterView';

export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			userName: {required},
			firstName: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				userName: { required: "User Name is Required."},
				firstName: { required : "First Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterUserInfo : null,
			currentUserInfoPage : 1,
			userInfoPageSize: 10,
			sortByUserInfo: '',
			sortDescUserInfo: '',
			approvalGroups: [],
			approvalGroups: [],
			isApprovalGroupComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isApprovalGroupComboLoading: false,
			vendors: [],
		}
	},
	methods : {
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfo : async function(id) {
			this.isBusy = true;
			UserInfo.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadUserInfo = true;
			this.filterUserInfo.id = this.modelId;
			UserInfo.downloadDataDetail(this, this.filterUserInfo).then(result => {
				this.isDownloadUserInfo = false;
			}).catch(error => { this.isDownloadUserInfo = false; })
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.FirstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getApprovalGroups : async function(input) {
			let filter = new ApprovalGroupFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalGroup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalGroups = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedApprovalGroup(item) {
			if(item == undefined || item == null) {
				this.model.approvalGroupId = null;
				this.model.approvalGroup = null;
			} else {
				this.model.approvalGroupId = item.id;
				this.model.approvalGroup = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.userInfoInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						UserInfo.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'userinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						UserInfo.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'userinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					UserInfo.updateData(this, model, id)
					.catch((error) => {
						this.getUserInfo(id);
					});
				}
			});
		},
		onHidden() {
			this.getUserInfos();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterUserInfo = new UserInfoFilter();
		//this.getApprovalGroups();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getUserInfo(id);
			} else {
				this.modelId = id;
				this.getUserInfo(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
